import Link from "next/link";
import s from "./SideLink.module.scss";
import { WrappedIcon } from "components/UI/WrappedIcon";
import { IconImageType } from "@/types/icon";
import IconArrowRight from "public/img/icons/svg/arrow-right.svg";
import { SpriteIcon } from "@/components/UI/SpriteIcon";
import cs from "@/styles/modules/card.module.scss";
import cn from "classnames";

type SideLinkProps = {
  icon: IconImageType;
  title: string;
  href: string;
};

export const SideLink = ({ icon, title, href }: SideLinkProps) => (
  <Link href={href} className={cn(cs.cardDefaultHover, s.sideLink)} prefetch={false}>
    <div className={s.sideLinkLeft}>
      <WrappedIcon className={s.sideLinkIcon} icon={icon} />
      {title}
    </div>
    <SpriteIcon icon={IconArrowRight} />
  </Link>
);
